<mat-slide-toggle [id]="id" [checked]="isChecked" [disabled]="disabled" (change)="onSlideChange($event)" aria-label="Toggle"></mat-slide-toggle>
